import type { ReactNode } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "@/app/store";
import { AppThemeProvider } from "@/app/theme/AppThemeProvider";
import { TenantConfigurationGate } from "@/features/app-config/ui/TenantConfigurationGate";
import { AuthProvider } from "@/shared/auth/AuthProvider";
import { AuthSessionWatcher } from "@/shared/auth/AuthSessionWatcher";
import { AppSnackbar } from "@/shared/notifications";

type AppProvidersProps = {
  children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <Provider store={store}>
      <AppThemeProvider>
        <AppSnackbar />
        <HelmetProvider>
          <BrowserRouter>
            <TenantConfigurationGate>
              <AuthProvider>
                <AuthSessionWatcher />
                {children}
              </AuthProvider>
            </TenantConfigurationGate>
          </BrowserRouter>
        </HelmetProvider>
      </AppThemeProvider>
    </Provider>
  );
}
